// Validates a ?next= value to a same-origin in-app path. Returns the path or null.
// Mirrors legacy src/scripts/pages/auth.js safeNextHash (history-mode equivalent).
export function safeNext(next: string | null | undefined): string | null {
  if (!next) return null;
  // Must start with exactly one slash (rejects "//evil" and "http://").
  if (!next.startsWith('/') || next.startsWith('//')) return null;
  // Reject anything that smells like a scheme before the first slash.
  if (/^[a-z][a-z0-9+.-]*:/i.test(next)) return null;
  // In-app paths never contain backslashes; reject to prevent backslash-redirect vectors.
  if (next.includes('\\')) return null;
  return next;
}
